module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container-fluid container-main"
  }, [_c('div', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('main-nav'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "app-view"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)]), _vm._v(" "), _c('copyright')], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('responsive')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51496740"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 99
// module chunks = 0